module.exports = __webpack_public_path__ + "img/gys-icon-3.ca2815bb.png";